import { render, staticRenderFns } from "./Guisos.vue?vue&type=template&id=4faaeb70&scoped=true"
import script from "./Guisos.vue?vue&type=script&lang=js"
export * from "./Guisos.vue?vue&type=script&lang=js"
import style0 from "./Guisos.vue?vue&type=style&index=0&id=4faaeb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faaeb70",
  null
  
)

export default component.exports